import React from "react";
import { useState } from "react";
import UserImage from "../../assets/userImage.png";
import { BsFillCloudUploadFill } from "react-icons/bs";
import Swal from "sweetalert2";
import MemberForm2 from "./MemberForm2";
import { toast } from "react-toastify";
import Header from "../../components/Header";
import { useAuth } from "../../context/Auth";
import InputField from "../../components/FormFields/InputField";
import RadioGroup from "../../components/FormFields/RadioGroup";
import { showApiErrors } from "../../utils/errorHandler";

const AddMember = () => {
  const { requestWithAuth } = useAuth();
  const [errors, setErrors] = useState({});
  const [page, setPage] = useState(1);
  const [file, setFile] = useState(null);
  const [data, setData] = useState({
    role: "Member",
  });
  const [spouseInfo, setSpouseInfo] = useState({});
  const [motherInfo, setMotherInfo] = useState({
    "relation": "Mother",
  })
  const [fatherInfo, setFatherInfo] = useState({
    "relation": "Father",
  })
  const [parentsInfo, setParentsInfo] = useState([
    motherInfo, fatherInfo
  ])
  const [workInfo, setWorkInfo] = useState({})
  const [emergencyContactInfo, setEmergencyContactInfo] = useState({})
  const [nextOfKinInfo, setNextOfKinInfo] = useState({})
  const [spiritualLifeInfo, setSpiritualLifeInfo] = useState({})
  const [submitting, setSubmitting] = useState(false);
  const [addingChildren, setAddingChildren] = useState(false);
  const [childFormFields, setChildFormFields] = useState([
    {
      srl: "",
      name: "",
      date_of_birth: "",
      gender: "",
      relationship: "",
    },
  ]);

  // CHANGING CHILD FORM FIELDS FOR CHILD DETAILS
  const handleChildFormFieldsChange = (e, index) => {
    const formData = [...childFormFields];
    formData[index][e.target.name] = e.target.value;
    setChildFormFields(formData);
  };

  // ADD MORE CHILDREN
  const addChildFields = () => {
    const object = {
      name: "",
      date_of_birth: "",
      gender: "",
      relationship: "",
    };
    setChildFormFields([...childFormFields, object]);
  };

  // REMOVE CHILD FIELDS
  const removeChildFields = (index) => {
    const formFieldData = [...childFormFields];
    formFieldData.splice(index, 1);
    setChildFormFields(formFieldData);
  };

  // SUBMIT FORM
  const submitForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      setSubmitting(true);
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      formData.append("spouse_info",spouseInfo)
      formData.append("parents",parentsInfo)
      formData.append("work_education",workInfo)
      formData.append("emergency_contacts", emergencyContactInfo)
      formData.append("next_of_kin", nextOfKinInfo)
      formData.append("spiritual_life", spiritualLifeInfo)
      formData.append("children", JSON.stringify(childFormFields));
      await requestWithAuth(
        `/members/`,
        "POST",
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );
      
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Member has been added successfully",
      }).then(() => {
        window.location.reload();
      });
      setSubmitting(false);
    } catch (error) {
      showApiErrors(error)
    }
  };

  // CREATE CHILDREN
  const addChildren = async (member_id) => {
    try {
      const body = JSON.stringify(childFormFields);
      const data = await requestWithAuth(
        `/members/member-child/${member_id}/`,
        "POST",
        body,
        {
          "Content-Type": "application/json",
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Member has been added successfully",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      setAddingChildren(false);
      setSubmitting(false);
      console.log(error);
      toast.error("An error occurred with adding children.");
    }
  };

  // HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFile(files[0]);
      setData({
        ...data,
        [name]: files[0],
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };

  const handleSpouseInfoChange = (e) => {
    setSpouseInfo({
      ...spouseInfo,
      [e.target.name]: e.target.value
    })
  }

  const handleFatherInfoChange = (e) => {
    setFatherInfo({
      ...fatherInfo,
      [e.target.name]: e.target.value
    })
  }

  const handleMotherInfoChange = (e) => {
    setMotherInfo({
      ...motherInfo,
      [e.target.name]: e.target.value
    })
  }

  const handleWorkInfoChange = (e) => {
    setWorkInfo({
      ...workInfo,
      [e.target.name]: e.target.value
    })
  }

  const handleEmergencyContactInfoChange = (e) => {
    setEmergencyContactInfo({
      ...emergencyContactInfo,
      [e.target.name]: e.target.value
    })
  }


  const handleSpiritualLifeInfoChange = (e) => {
    setSpiritualLifeInfo({
      ...spiritualLifeInfo,
      [e.target.name]: e.target.value
    })
  }

  const handleNextOfKinInfoChange = (e) => {
    setNextOfKinInfo({
      ...nextOfKinInfo,
      [e.target.name]: e.target.value
    })
  }

  const validateForm = () => {
    const newErrors = {};
    if (!data.first_name) newErrors.first_name = "First Name is required.";
    if (!data.last_name) newErrors.last_name = "Last Name is required.";
    if (!data.gender) newErrors.gender = "Gender is required.";
    if (!data.address) newErrors.address = "Address is required.";
    if (!data.phone_number)
      newErrors.phone_number = "Phone Number is required.";
    if (!data.hometown) newErrors.hometown = "Hometown is required.";
    if (!data.residence) newErrors.residence = "Residence is required.";
    if (!data.marital_status)
      newErrors.marital_status = "Marital Status is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div>
      <Header title="Add New Member" />
      {/* PAGE 1 */}
      {page === 1 && (
        <div className="border border-gray-500">
          {/* PERSONAL INFORMATION */}
          <div className="">
            <div className="bg-primary text-secondary px-5 py-2">
              PERSONAL INFORMATION
            </div>
            <div className="personal-info-section member-form-body">
              <div className="p-5">
                <div className="h-52 w-52">
                  <img
                    src={file ? URL.createObjectURL(file) : UserImage}
                    alt="user"
                    className="h-full w-full object-cover rounded-full border-2 border-gray-500 cursor-pointer hover:border-blue-500 transition duration-300 ease-in-out"
                  />
                </div>
                <input
                  type="file"
                  accept="image/*"
                  name="profile_picture"
                  id="profile_picture"
                  className="hidden"
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                    setData({
                      ...data,
                      [e.target.name]: e.target.files[0],
                    });
                  }}
                />
                <label
                  id="upload-button"
                  className="flex gap-2 items-center cursor-pointer w-max mt-2 bg-blue-500 text-white px-3 py-2 rounded"
                  htmlFor="profile_picture"
                >
                  <BsFillCloudUploadFill />
                  Upload File
                </label>
                <p style={{ fontWeight: "400", fontSize: "12px" }}>
                  {file ? file.name : "No file selected"}
                </p>
              </div>
              <div className="grid lg:grid-cols-3 gap-5 pt-0 p-5">
                <InputField
                  label="First Name"
                  name="first_name"
                  value={data.first_name}
                  onChange={handleChange}
                  required
                  error={errors.first_name}
                />
                <InputField
                  label="Last Name"
                  name="last_name"
                  value={data.last_name}
                  onChange={handleChange}
                  required
                  error={errors.last_name}
                />

                <RadioGroup
                  label="Gender"
                  name="gender"
                  options={[
                    { label: "Male", value: "Male" },
                    { label: "Female", value: "Female" },
                  ]}
                  value={data.gender}
                  onChange={handleChange}
                  required
                  error={errors.gender}
                />

                <InputField
                  label="Address"
                  name="address"
                  value={data.address}
                  onChange={handleChange}
                  required
                  error={errors.address}
                />

                <InputField
                  label="Phone Number"
                  name="phone_number"
                  value={data.phone_number}
                  onChange={handleChange}
                  required
                  error={errors.phone_number}
                />
                <InputField
                  label="Email"
                  name="email"
                  type="email"
                  value={data.email}
                  onChange={handleChange}
                />

                <InputField
                  label="Date of Birth"
                  name="date_of_birth"
                  type="date"
                  value={data.date_of_birth}
                  onChange={handleChange}
                  error={errors.date_of_birth}
                />

                <InputField
                  label="Hometown"
                  name="hometown"
                  value={data.hometown}
                  onChange={handleChange}
                  required
                  error={errors.hometown}
                />

                <InputField
                  label="Nationality"
                  name="nationality"
                  value={data.nationality}
                  onChange={handleChange}
                  required
                  error={errors.nationality}
                />

                <InputField
                  label="Residence"
                  name="residence"
                  value={data.residence}
                  onChange={handleChange}
                  required
                  error={errors.residence}
                />
                <InputField
                  label="Language Spoken"
                  name="language_spoken"
                  value={data.language_spoken}
                  onChange={handleChange}
                  error={errors.language_spoken}
                />
                {/* FIFTH ROW */}
                <div className="member-form-row">
                  {/* MARITAL STATUS */}
                  <RadioGroup
                    label="Marital Status"
                    name="marital_status"
                    options={[
                      { label: "Single", value: "Single" },
                      { label: "Married", value: "Married" },
                      { label: "Divorced", value: "Divorced" },
                      { label: "Remarried", value: "Remarried" },
                      { label: "Co-Habitation", value: "Co-Habitation" },
                    ]}
                    value={data.marital_status}
                    onChange={handleChange}
                    required
                    error={errors.marital_status}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* SPIRITUAL LIFE INFORMATION */}
          <div>
            <div className="bg-primary text-secondary px-5 py-2">
              SPIRITUAL LIFE INFORMATION
            </div>
            <div className="member-form-body">
              <div className="grid lg:grid-cols-3 gap-5 p-5">
                <div className="flex flex-col">
                  <label htmlFor="">Previous Church</label>
                  <input
                    type="text"
                    name="previous_church"
                    id="previous_church"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    value={spiritualLifeInfo?.previous_church}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Location</label>
                  <input
                    type="text"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    name="location"
                    id="location"
                    value={spiritualLifeInfo?.location}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Pastor In Charge</label>
                  <input
                    type="text"
                    name="pastor_in_charge"
                    id="pastor_in_charge"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    value={spiritualLifeInfo?.pastor_in_charge}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Reason For Leaving</label>
                  <input
                    type="text"
                    name="leaving_reason"
                    id="leaving_reason"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    value={spiritualLifeInfo?.leaving_reason}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Contact Number</label>
                  <input
                    type="text"
                    name="contact_number"
                    id="contact_number"
                    value={spiritualLifeInfo?.contact_number}
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Tithe Card Number</label>
                  <input
                    type="text"
                    name="tithe_number"
                    id="tithe_number"
                    value={spiritualLifeInfo?.tithe_number}
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Area of Ministry/Gifting</label>
                  <input
                    type="text"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                    name="ministry"
                    id="ministry"
                    value={spiritualLifeInfo?.ministry}
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Date You Completed Membership Class</label>
                  <input
                    type="date"
                    name="membership_class_completion_date"
                    id="membership_class_completion_date"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                    value={spiritualLifeInfo?.membership_class_completion_date}
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Baptismal Date</label>
                  <input
                    type="date"
                    name="baptismal_date"
                    id="baptismal_date"
                    onChange={(e) => handleSpiritualLifeInfoChange(e)}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                    value={spiritualLifeInfo?.baptismal_date}
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Baptismal Type</label>
                  <div className="radio-row">
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="baptismal_type"
                        value="Immersion"
                        defaultChecked={spiritualLifeInfo?.baptismal_type === "Immersion"}
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                      />{" "}
                      Immersion
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="baptismal_type"
                        value="Sprinkle"
                        defaultChecked={spiritualLifeInfo?.baptismal_type === "Sprinkle"}
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                      />{" "}
                      Sprinkle
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="baptismal_type"
                        value="Other"
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        defaultChecked={spiritualLifeInfo?.baptismal_type === "Other"}
                      />{" "}
                      Other
                    </div>
                  </div>
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Are You Born Again?</label>
                  <div className="radio-row">
                    <div className="radio-item">
                      <input
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        type="radio"
                        name="born_again"
                        value="Yes"
                        defaultChecked={spiritualLifeInfo?.born_again === "Yes"}
                      />{" "}
                      Yes
                    </div>
                    <div className="radio-item">
                      <input
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        type="radio"
                        name="born_again"
                        value="No"
                        defaultChecked={spiritualLifeInfo?.born_again === "No"}
                      />{" "}
                      No
                    </div>
                  </div>
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Holy Spirit Baptized?</label>
                  <div className="radio-row">
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="holy_spirit_baptized"
                        value="Yes"
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        defaultChecked={spiritualLifeInfo?.holy_spirit_baptized === "Yes"}
                      />{" "}
                      Yes
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="holy_spirit_baptized"
                        value="No"
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        defaultChecked={spiritualLifeInfo?.holy_spirit_baptized === "No"}
                      />{" "}
                      No
                    </div>
                  </div>
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Speaking in Tongues</label>
                  <div className="radio-row">
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="speaking_in_tongues"
                        value="Yes"
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        defaultChecked={spiritualLifeInfo?.speaking_in_tongues === "Yes"}
                      />{" "}
                      Yes
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        name="speaking_in_tongues"
                        value="No"
                        onChange={(e) => handleSpiritualLifeInfoChange(e)}
                        defaultChecked={spiritualLifeInfo?.speaking_in_tongues === "No"}
                      />{" "}
                      No
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAMILY INFORMATION */}
          <div className="member-form-section">
            <div className="bg-primary text-secondary px-5 py-2">
              FAMILY INFORMATION
            </div>
            <div className="">
              <div className="grid lg:grid-cols-3 gap-5 p-5">
                <div className="flex flex-col">
                  <label htmlFor="">Name of Spouse</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    onChange={(e) => handleSpouseInfoChange(e)}
                    value={spouseInfo?.name}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Date of Marriage</label>
                  <input
                    type="date"
                    name="date_of_marriage"
                    id="date_of_marriage"
                    onChange={(e) => handleSpouseInfoChange(e)}
                    value={spouseInfo?.date_of_marriage}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Type of Marriage</label>
                  <input
                    type="text"
                    name="type_of_marriage"
                    id="type_of_marriage"
                    onChange={(e) => handleSpouseInfoChange(e)}
                    value={spouseInfo?.type_of_marriage}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Spouse Church</label>
                  <input
                    type="text"
                    name="spouse_church"
                    id="spouse_church"
                    onChange={(e) => handleSpouseInfoChange(e)}
                    value={data?.spouse_church}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Occupation of spouse</label>
                  <input
                    type="text"
                    name="occupation_of_spouse"
                    id="occupation_of_spouse"
                    onChange={(e) => handleSpouseInfoChange(e)}
                    value={spouseInfo?.occupation_of_spouse}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="">Spouse Contact Number</label>
                  <input
                    type="text"
                    name="spouse_contact_number"
                    id="spouse_contact_number"
                    onChange={(e) => handleSpouseInfoChange(e)}
                    value={spouseInfo?.spouse_contact_number}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* CHILDREN / DEPENDANT */}
          <div className="member-form-section">
            <div className="bg-primary text-secondary px-5 py-2">
              CHILDREN / DEPENDENTS
            </div>
            <div>
              <div>
                {childFormFields.map((childFormField, index) => (
                  <div className="border-t border-gray-500">
                    <div className="grid lg:grid-cols-3 gap-5 p-5">
                      <div className="flex flex-col">
                        <label htmlFor="">Child Number</label>
                        <input
                          type="text"
                          name="srl"
                          id="srl"
                          onChange={(e) =>
                            handleChildFormFieldsChange(e, index)
                          }
                          value={childFormFields[index]["srl"]}
                          className="border border-gray-500 px-3 py-2 outline-none rounded"
                        />
                      </div>

                      <div className="flex flex-col">
                        <label htmlFor="">Name</label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          onChange={(e) =>
                            handleChildFormFieldsChange(e, index)
                          }
                          value={childFormFields[index]["name"]}
                          className="border border-gray-500 px-3 py-2 outline-none rounded"
                        />
                      </div>

                      <div className="flex flex-col">
                        <label htmlFor="">Date of birth</label>
                        <input
                          type="date"
                          name="date_of_birth"
                          id="date_of_birth"
                          onChange={(e) =>
                            handleChildFormFieldsChange(e, index)
                          }
                          value={childFormFields[index]["date_of_birth"]}
                          className="border border-gray-500 px-3 py-2 outline-none rounded"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label htmlFor="">Gender</label>
                        <div className="radio-row">
                          <div className="radio-item">
                            <input
                              type="radio"
                              name="gender"
                              value="Male"
                              onChange={(e) =>
                                handleChildFormFieldsChange(e, index)
                              }
                              defaultChecked={
                                childFormFields[index]["gender"] === "Male"
                              }
                            />{" "}
                            Male
                          </div>
                          <div className="radio-item">
                            <input
                              type="radio"
                              name="gender"
                              value="Female"
                              onChange={(e) =>
                                handleChildFormFieldsChange(e, index)
                              }
                              defaultChecked={
                                childFormFields[index]["gender"] === "Female"
                              }
                            />{" "}
                            Female
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col">
                        <label htmlFor="">Relationship</label>
                        <input
                          type="text"
                          name="relationship"
                          id="relationship"
                          onChange={(e) =>
                            handleChildFormFieldsChange(e, index)
                          }
                          value={childFormFields[index]["relationship"]}
                          className="border border-gray-500 px-3 py-2 outline-none rounded"
                        />
                      </div>

                      <div className="flex flex-col">
                        <label htmlFor="">
                          Is this child a member of this church?
                        </label>
                        <select
                          onChange={(e) =>
                            handleChildFormFieldsChange(e, index)
                          }
                          className="border border-gray-500 px-3 py-2 outline-none rounded"
                          name="church_member"
                          id="church_member"
                        >
                          <option
                            value="Yes"
                            selected={
                              childFormFields[index]["church_member"] == "Yes"
                            }
                          >
                            Yes
                          </option>
                          <option
                            value="No"
                            selected={
                              childFormFields[index]["church_member"] == "No"
                            }
                          >
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    {/* REMOVE CHILD BUTTON */}
                    {index > 0 && (
                      <div
                        onClick={() => removeChildFields(index)}
                        className="mt-3 cursor-pointer font-[600] bg-red-600 px-6 py-4 text-white text-center"
                      >
                        + Remove This Child
                      </div>
                    )}
                  </div>
                ))}

                {/* ADD MORE BUTTON */}
                <div
                  className="bg-blue-500 text-secondary text-center px-6 py-4 font-[600] cursor-pointer"
                  onClick={addChildFields}
                >
                  + Add Another Child
                </div>
              </div>
            </div>
          </div>

          <div className="continue-button p-5 flex justify-end gap-3">
            <div className="md:col-span-2 lg:col-span-3 flex justify-end">
              <button
                onClick={(e) => submitForm(e)}
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-md shadow-md hover:shadow-lg transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Saving...
                  </>
                ) : (
                  "Save Member"
                )}
              </button>
            </div>
            <div
              className="default-button"
              onClick={() => {
                // setData({ ...data, children: childFormFields });
                setPage(2);
              }}
            >
              Continue
            </div>
          </div>
        </div>
      )}

      {/* PAGE 2 */}
      {page === 2 && (
        <MemberForm2
          setPage={setPage}
          data={data}
          handleChange={handleChange}
          submitting={submitting}
          submitForm={submitForm}
          workInfo={workInfo}
          handleWorkInfoChange={handleWorkInfoChange}
          nextOfKinInfo={nextOfKinInfo}
          handleNextOfKinInfoChange={handleNextOfKinInfoChange}
          emergencyContactInfo={emergencyContactInfo}
          handleEmergencyContactInfoChange={handleEmergencyContactInfoChange}
          fatherInfo={fatherInfo}
          motherInfo={motherInfo}
          handleFatherInfoChange={handleFatherInfoChange}
          handleMotherInfoChange={handleMotherInfoChange}
        />
      )}
    </div>
  );
};

export default AddMember;
